import { AdminDependenciesState } from './models';

export const namespace = 'vtn-redact-state-admin-dependencies';

export const defaultState: AdminDependenciesState = {
  status: 'idle',
  results: [],
};

export interface AdminDependenciesStore {
  [namespace]: AdminDependenciesState;
}
